import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { useCheckAccess } from "../../utils/Utilities";
import axios from 'axios';

const ExpenseApprove = () => {
  useCheckAccess('ExpenseApprove');
  const [familyId, setFamilyId] = useState('');
  const [expenseId, setExpenseId] = useState('');
  const [month, setMonth] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/expenses/logToMonthlyStatement', {
        familyId,
        expenseId,
        month,
      });
      alert('Logged to monthly statement');
    } catch (err) {
      alert('Failed to log expense');
    }
  };

  return (
    <div>
      <Navbar />
      <Helmet><title>Log Expense</title></Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className='general_body'>
            <Breadcrumbs /><br />
            <h2>மாதாந்திரச் சுருக்கத்தில் செலவினங்களை பதிவு செய்யுங்கள்</h2>
            <br />
            <form onSubmit={handleSubmit} className="p-4 space-y-4">
              <input value={familyId} onChange={e => setFamilyId(e.target.value)} placeholder="Family ID" required className="border p-2 w-full" />
              <input value={expenseId} onChange={e => setExpenseId(e.target.value)} placeholder="Expense ID" required className="border p-2 w-full" />
              <input value={month} onChange={e => setMonth(e.target.value)} placeholder="Month (YYYY-MM)" required className="border p-2 w-full" />
              <button type="submit" className="bg-purple-500 text-white px-4 py-2 rounded">Log to Monthly Statement</button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default ExpenseApprove;